import { PropsWithChildren } from 'react';
import PullToRefresh from 'react-simple-pull-to-refresh';
import React from 'react';

const PullableWrapper: React.FC<PropsWithChildren> = ({
  children,
}): React.ReactElement => {
  const handleRefresh = async () => {
    window.location.reload();
  };

  return (
    <PullToRefresh onRefresh={handleRefresh}>
      <>{children}</>
    </PullToRefresh>
  );
};

export default PullableWrapper;
